import {
    // IChartShapeProps,
    IChartSpace,
    ShapeProps,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import {
    type NullableDeep,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property.interface';
import { IChartSpaceProperty } from './chart-space.interface';
import ChartShapeProperty from '../chart-shape-property';

export class ChartSpaceProperty<T extends ShapeProps = ShapeProps>
    extends ChartShapeProperty<T> implements IChartSpaceProperty {
    private chartSpace: IChartSpace;
    public initChartSpace(chartSpace: IChartSpace) {
        this.chartSpace = chartSpace;
    }
    public updateProps(updateProps: Partial<ShapeProps>, removeProps?: Partial<NullableDeep<ShapeProps>> | null): void {
        const chartModel = this.context.getChartModel();
        chartModel.updateProps({ chartSpace: updateProps });
    }
}
